import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { CapsuleButton } from "../../../../../../../../CommonComponents/Commons/commonComponents";
import { CapsuleButtonWrapper } from "../../../../../MakeAContribution/Components/ContributionType/styles";
import { Content, SectionHeading } from "../../styles";
import { ContributionName, ComponentDivider } from "../ContributionType/styles";
import formatter from "../../../../../../../../utils/formatter";
import { GiftWrapper, FontBoldText } from "./styles";
import { getPrimaryAccount } from "../../../../../../../../utils/sessionUtil";
import { recordError } from "../../../../../../../../utils/commonUtil";
import { fundingInstructionsState } from "../../../../selectors";
let assetMF = [];
let assetSG = [];
let assetOutMF = [];
let assetOutSG = [];
let check = [];
let wire = [];
let stockCert = [];
const basePath = process.env.PUBLIC_URL || '/';
const envURL = process.env.REACT_APP_DRUPAL_BASE_URL;

export class ContributionType extends React.Component {
  constructor(props) {
    super(props);
  }

  clickAssetHeldMF = (data, name, path) => {
    try {
      localStorage[name] = JSON.stringify(data);
      if (process.env.REACT_APP_NODE_ENV !== "development") {
        path = basePath + path;
      }
      path = path + '?isRefresh=true';
      const win = window.open(path, '_blank');
      win.focus();
    } catch (error) {
      recordError(error);
    }
  }

  renderContributionTypes = (contribution,name,donorDisplayName,loggedInAddress,count,contributionTypes) => {
    let address = {};
    let donorAddress = {};
    let donorType = "";
    let loggedInUserName = "";
    let donorUserName = "";
    if (contribution.donorType == "I") {
      donorType = "Individual";
      address = loggedInAddress;
      loggedInUserName = donorDisplayName;
    } else if (contribution.donorType == "J") {
      donorType = "Joint";
      address = loggedInAddress;
      donorAddress = contribution.donorAddress;
      loggedInUserName = donorDisplayName;
      donorUserName =
        (contribution.donorFirstName ? contribution.donorFirstName : "") +
        (contribution.donorLastName ? " " + contribution.donorLastName : "");
    } else if (contribution.donorType == "30") {
      donorType = "Trust";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "10") {
      donorType = "Corporation";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "20") {
      donorType = "Private Foundation";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "70") {
      donorType = "Other donor-advised Fund";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "40") {
      donorType = "Other";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "50") {
      donorType = "Estate";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "60") {
      donorType = "Public Charity";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "80") {
      donorType = "Government Grant/Contract";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "90") {
      donorType = "Non-Charitable Tax-Exempt Organization";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "100") {
      donorType = "Church/School/Medical Institution";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "110") {
      donorType = "Partnership";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    }

    if (contribution.stpWorkflow == "Y") {
      if (contribution.donorType == "I") {
        donorType = "Individual";
        address = contributionTypes.vgiAddressDetails;
        loggedInUserName = donorDisplayName;
      } else if (contribution.donorType == "J") {
        donorType = "Joint";
        donorAddress = contributionTypes.vgiAddressDetails;
        donorUserName = contributionTypes.vgiJointDonor
          ? contributionTypes.vgiJointDonor
          : "";
      } else if (contribution.donorType == "30") {
        donorType = "Trust";
        donorAddress = contributionTypes.vgiAddressDetails;
        donorUserName =
          (contributionTypes.vgiTrustName
            ? contributionTypes.vgiTrustName
            : "") +
          (contributionTypes.vgiJointTrustee
            ? ", " + contributionTypes.vgiJointTrustee
            : "");
      }
    }

    let type = address ? (address.addrType ? address.addrType.codeId : "") : "";
    let addressType = "";
    if (type !== "") {
      if (type == "1000") {
        addressType = "Business, ";
      } else if (type == "1001") {
        addressType = "Home";
      } else if (type == "1002") {
        addressType = "Mailing";
      } else if (type == "1003") {
        addressType = "Physical";
      } else if (type == "1004") {
        addressType = "Summer";
      } else if (type == "1005") {
        addressType = "Winter";
      } else if (type == "1006") {
        addressType = "Other";
      }
    }
    let donoraddressType = "";
    let donoraaddressType = donorAddress
      ? donorAddress.addrType
        ? donorAddress.addrType.codeId
        : ""
      : "";
    if (donoraaddressType !== "") {
      if (donoraaddressType == "1000") {
        donoraddressType = "Business";
      } else if (donoraaddressType == "1001") {
        donoraddressType = "Home";
      } else if (donoraaddressType == "1002") {
        donoraddressType = "Mailing";
      } else if (donoraaddressType == "1003") {
        donoraddressType = "Physical";
      } else if (donoraaddressType == "1004") {
        donoraddressType = "Summer";
      } else if (donoraaddressType == "1005") {
        donoraddressType = "Winter";
      } else if (donoraaddressType == "1006") {
        donoraddressType = "Other";
      }
    }
    if (name == "Securities") {
      let origin = contribution.origination;
      if (origin) {
        if (origin.codeType == "SECURITY_ORIGINATION") {
          if (origin.codeValue == "10" || origin.codeValue == "40") {
            name = "Asset Held at Vanguard - Securities";
          } else if (origin.codeValue == "20") {
            name = "Asset Held Outside Vanguard - Securities";
          } else if (origin.codeValue == "30") {
            name = "Stock Certificates";
          }
        }
      }
      if (contribution.nonVBSMutualFundFlag) {
        name = "Asset Held Outside Vanguard - Mutual Funds";
      }

      if(contribution.stpWorkflow === "Y"){
        name = 'VBS Security';
      }

    } else if (name == "Funds") {
      let origin = contribution.origination;
      if (origin) {
        if (origin.codeValue == "10" || origin.codeValue == "20") {
          name = "Asset Held at Vanguard - Mutual Funds";
        } else if (origin.codeValue == "30") {
          name = "Asset Held Outside Vanguard - Mutual Funds";
        }

        if(contribution.stpWorkflow === "Y") {
          name = 'Mutual Fund';
        }
      }
    }

    if (name == "Wire") {
      if (contribution.stpWorkflow == "Y") {
        name = "Settlement Fund"
      }
    }
    let settleDate = "";
    if (name === "Asset Held Outside Vanguard - Securities" || name === "Asset Held at Vanguard - Securities" || name === "Stock Certificates") {
      if (contribution.lotDetails && contribution.lotDetails[0] && contribution.lotDetails[0].lot && contribution.lotDetails[0].lot["settlement"] && contribution.lotDetails[0].lot["settlement"].settlementDate) {
        settleDate = contribution.lotDetails[0].lot["settlement"].settlementDate;
      }
    } else {
      settleDate = contribution.settlementDate ? contribution.settlementDate : null;
    }

    if (name === "Asset Held at Vanguard - Mutual Funds") {
      assetMF.push({
        envURL: envURL,
        giftId: contribution.giftId,
        logAcName: getPrimaryAccount().accountName,
        logAcNum: getPrimaryAccount().accountNumber,
        name: loggedInUserName,
        donorName: donorUserName,
        accountNumber: contribution.accountNumber,
        type: donorType,
        firstName: contribution.donorFirstName,
        lastName: contribution.donorLastName,
        ticker: contribution.ticker,
        fundName: contribution.name,
        fundNumber: contribution.fundNumber,
        allShares: contribution.allShares,
        shares: contribution.shares ? contribution.shares.toFixed(3).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '',
        status: contribution.giftStatus.extDescription
      })
    }
    if (name === "Asset Held at Vanguard - Securities") {
      assetSG.push({
        envURL: envURL,
        giftId: contribution.giftId,
        logAcName: getPrimaryAccount().accountName,
        logAcNum: getPrimaryAccount().accountNumber,
        name: loggedInUserName,
        donorName: donorUserName,
        accountNumber: contribution.accountNumber,
        type: donorType,
        firstName: contribution.donorFirstName,
        lastName: contribution.donorLastName,
        ticker: contribution.ticker,
        fundName: contribution.name,
        fundNumber: contribution.nonVbsFundNumber,
        allShares: contribution.allShares,
        shares: contribution.shares ? contribution.shares.toFixed(3).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '',
        status: contribution.giftStatus.extDescription
      })
    }
    if (name === "Asset Held Outside Vanguard - Mutual Funds") {
      assetOutMF.push({
        envURL: envURL,
        giftId: contribution.giftId,
        logAcName: getPrimaryAccount().accountName,
        logAcNum: getPrimaryAccount().accountNumber,
        name: loggedInUserName,
        donorName: donorUserName,
        accountNumber: contribution.accountNumber ? contribution.accountNumber : "",
        firm: contribution.originatingFirmName ? contribution.originatingFirmName : "",
        type: donorType,
        firstName: contribution.donorFirstName,
        lastName: contribution.donorLastName,
        ticker: contribution.ticker,
        fundName: contribution.name,
        fundNumber: contribution.nonVbsFundNumber,
        allShares: contribution.allShares,
        shares: contribution.shares ? contribution.shares.toFixed(3).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '',
        status: contribution.giftStatus.extDescription
      })
    }
    if (name === "Asset Held Outside Vanguard - Securities") {
      assetOutSG.push({
        envURL: envURL,
        giftId: contribution.giftId,
        logAcName: getPrimaryAccount().accountName,
        logAcNum: getPrimaryAccount().accountNumber,
        name: loggedInUserName,
        donorName: donorUserName,
        type: donorType,
        accountNumber: contribution.accountNumber ? contribution.accountNumber : "",
        firm: contribution.originatingFirmName ? contribution.originatingFirmName : "",
        firstName: contribution.donorFirstName,
        lastName: contribution.donorLastName,
        ticker: contribution.ticker,
        fundName: contribution.name,
        fundNumber: contribution.nonVbsFundNumber,
        allShares: contribution.allShares,
        shares: contribution.shares ? contribution.shares.toFixed(3).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '',
        status: contribution.giftStatus.extDescription
      })
    }
    if (name === "Check or Electronic Bank Transfer") {
      check.push({
        envURL: envURL,
        giftId: contribution.giftId,
        logAcName: getPrimaryAccount().accountName,
        logAcNum: getPrimaryAccount().accountNumber,
        name: loggedInUserName,
        type: donorType,
        firstName: contribution.donorFirstName,
        lastName: contribution.donorLastName,
        donorName: donorUserName,
        amount: formatter({
          value: contribution.amount,
          fieldSuffix: "Dollars"
        }),
        status: contribution.giftStatus.extDescription,
        drupalContent: this.props.drupalData && this.props.drupalData.description__value
      })
    }
    if (name === "Wire") {
      wire.push({
        envURL: envURL,
        giftId: contribution.giftId,
        logAcName: getPrimaryAccount().accountName,
        logAcNum: getPrimaryAccount().accountNumber,
        name: loggedInUserName,
        donorName: donorUserName,
        type: donorType,
        firstName: contribution.donorFirstName,
        lastName: contribution.donorLastName,
        amount: contribution.amount ? formatter({
          value: contribution.amount,
          fieldSuffix: "Dollars"
        }) : '',
        allocationDetails: this.props.contributionTypes.investmentOption,
        status: contribution.giftStatus.extDescription,
        drupalContent: this.props.drupalData && this.props.drupalData.description__value
      })
    }
    if (name === "Stock Certificates") {
      stockCert.push({
        envURL: envURL,
        giftId: contribution.giftId,
        logAcName: getPrimaryAccount().accountName,
        logAcNum: getPrimaryAccount().accountNumber,
        name: loggedInUserName,
        donorName: donorUserName,
        type: donorType,
        firstName: contribution.donorFirstName,
        lastName: contribution.donorLastName,
        accountNumber: contribution.accountNumber,
        ticker: contribution.ticker,
        fundName: contribution.name,
        allShares: contribution.allShares,
        shares: contribution.shares ? contribution.shares.toFixed(3).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : "",
        status: contribution.giftStatus.extDescription
      })
    }
  };

  render() {
    assetMF = [];
    assetSG = [];
    assetOutMF = [];
    assetOutSG = [];
    check = [];
    wire = [];
    stockCert = [];
    const { contributionTypes } = this.props;

    if (contributionTypes.funds && contributionTypes.funds.length) {
      contributionTypes.funds.map((fund, index) =>
      !["Completed","Cancelled"].includes(fund.giftStatus.extDescription) && this.renderContributionTypes(
          fund,
          "Funds",
          contributionTypes.donorDisplayName,
          contributionTypes.donorDisplayAddress,
          index + 1,
          contributionTypes
        )
      )
    }
    if (contributionTypes.securities && contributionTypes.securities.length) {
      contributionTypes.securities.map((fund, index) =>
      !["Completed","Cancelled"].includes(fund.giftStatus.extDescription) && this.renderContributionTypes(
          fund,
          "Securities",
          contributionTypes.donorDisplayName,
          contributionTypes.donorDisplayAddress,
          index + 1,
          contributionTypes
        )
      )
    }
    if (contributionTypes.checks && contributionTypes.checks.length) {
      contributionTypes.checks.map((fund, index) =>
      !["Completed","Cancelled"].includes(fund.giftStatus.extDescription) && this.renderContributionTypes(
          fund,
          "Check or Electronic Bank Transfer",
          contributionTypes.donorDisplayName,
          contributionTypes.donorDisplayAddress,
          index + 1,
          contributionTypes
        )
      )
    }
    if (contributionTypes.wires && contributionTypes.wires.length) {
      contributionTypes.wires.map((fund, index) =>
      !["Completed","Cancelled"].includes(fund.giftStatus.extDescription) && this.renderContributionTypes(
          fund,
          "Wire",
          contributionTypes.loginPartyName,
          contributionTypes.donorDisplayAddress,
          index + 1,
          contributionTypes
        )
      )
    }
    return contributionTypes ? (
      <>
        {assetMF.length || assetSG.length || assetOutMF.length || assetOutSG.length || check.length || wire.length || stockCert.length ?
          <>
            <SectionHeading fontSize="24px" marginBottom="15px" mobileFont="20px">Funding Instructions</SectionHeading>
            <Content marginBottom="30px" mB='20px'>Please use the <FontBoldText>Generate Funding Instructions</FontBoldText> button(s) below if you were unable to print them in Step 4 of submitting a contribution online.<FontBoldText> Note:</FontBoldText> Do not submit these instructions more than once, as this could result in a delay or duplication of your contribution.</Content>
          </>
          : ''}
        {assetMF.length > 0 ?
          <>
            <ContributionName paddingBottom="15px">Asset Held At Vanguard Mutual Funds</ContributionName>
            <Content marginBottom="30px" mB='20px'>Please follow instructions provided.</Content>
            <CapsuleButtonWrapper marginBottom="30px">
            <GiftWrapper>
            <div>Gift Id: {assetMF[0].giftId}</div>
            <CapsuleButton
              text= "View Funding Instructions"
              data-test="view-funding-instructions"
              onClick={() => this.clickAssetHeldMF(assetMF, "assetMF", '/AssetheldMF')}
            />
            </GiftWrapper>
            </CapsuleButtonWrapper>
            <ComponentDivider bottom='40px' mobileBottom='30px' top='40px' mobileTop='30px'/>
          </>
           : ''}

        {assetSG.length > 0 ?
          <>
            <ContributionName paddingBottom="15px">Asset Held At Vanguard Securities</ContributionName>
            <Content marginBottom="30px" mB='20px'>Please follow instructions provided.</Content>
            <CapsuleButtonWrapper marginBottom="30px">
            <GiftWrapper>
            <div>Gift Id: {assetSG[0].giftId}</div>
            <CapsuleButton
              text= "View Funding Instructions"
              data-test="view-funding-instructions-2"
              onClick={() => this.clickAssetHeldMF(assetSG, "assetSG", '/AssetheldSecurity')}
            />
            </GiftWrapper>
            </CapsuleButtonWrapper>
            <ComponentDivider bottom='40px' mobileBottom='30px' top='40px' mobileTop='30px'/>
          </>
           : ''}

        {assetOutMF.length > 0 ?
          <>
            <ContributionName paddingBottom="15px">Asset Held Outside Vanguard Mutual Funds</ContributionName>
            <Content marginBottom="30px" mB='20px'>Please follow instructions provided.</Content>
            <CapsuleButtonWrapper marginBottom="30px">
            <GiftWrapper>
            <div>Gift Id: {assetOutMF[0].giftId}</div>
            <CapsuleButton
              text= "View Funding Instructions"
              data-test="view-funding-instructions-3"
              onClick={() => this.clickAssetHeldMF(assetOutMF, "assetOutMF", '/AssetOutsideMF')}
            />
            </GiftWrapper>
            </CapsuleButtonWrapper>
            <ComponentDivider bottom='40px' mobileBottom='30px' top='40px' mobileTop='30px'/>
          </>
           : ''}

        {assetOutSG.length > 0 ?
          <>
            <ContributionName paddingBottom="15px">Asset Held Outside Vanguard Securities</ContributionName>
            <Content marginBottom="30px" mB='20px'>Please follow instructions provided.</Content>
            <CapsuleButtonWrapper marginBottom="30px">
            <GiftWrapper>
            <div>Gift Id: {assetOutSG[0].giftId}</div>
            <CapsuleButton
              text= "View Funding Instructions"
              data-test="view-funding-instructions-4"
              onClick={() => this.clickAssetHeldMF(assetOutSG, "assetOutSG", '/AssetsOutsideSecurity')}
            />
            </GiftWrapper>
            </CapsuleButtonWrapper>
            <ComponentDivider bottom='40px' mobileBottom='30px' top='40px' mobileTop='30px'/>
          </>
          : ''}

        {check.length > 0 ?
          (
            <>
              {check.map((chec, index) => {
                return (
                  <div>
                    {
                      index === 0 ?
                        <>
                          <ContributionName paddingBottom="15px">Check or EBT</ContributionName>
                          <Content marginBottom="30px" mB='20px'>Print the form to accompany your check. This form also includes instructions on how to initiate your EBT.</Content>
                        </>
                        : ''
                    }
                    <CapsuleButtonWrapper marginBottom="30px">
                    <GiftWrapper>
                      <div>Gift Id: {chec.giftId}</div>
                      <CapsuleButton
                        text= "View Funding Instructions"
                        data-test="view-funding-instructions-5"
                        onClick={() => this.clickAssetHeldMF(chec, "check", '/Check')}
                      />
                    </GiftWrapper>
                    </CapsuleButtonWrapper>
                  </div>
                )
              })}
              <ComponentDivider bottom='40px' mobileBottom='30px' top='40px' mobileTop='30px'/>
            </>
          )
          : ''}

        {wire.length > 0 ?
          (
            <>
              {wire.map((wir, index) => {
                return (
                  <div>
                    {
                      index === 0 ?
                        <>
                          <ContributionName paddingBottom="15px">Wire</ContributionName>
                          <Content marginBottom="30px" mB='20px'>Please provide Wiring Instructions to your financial Institution.</Content>
                        </>
                        : ''
                    }
                    <CapsuleButtonWrapper marginBottom="30px">
                    <GiftWrapper>
                      <div>Gift Id: {wir.giftId}</div>
                      <CapsuleButton
                        text= "View Funding Instructions"
                        data-test="view-funding-instructions-6"
                        onClick={() => this.clickAssetHeldMF(wir, "wire", '/Wire')}
                      />
                    </GiftWrapper>
                    </CapsuleButtonWrapper>
                  </div>
                )
              })}
              <ComponentDivider bottom='40px' mobileBottom='30px' top='40px' mobileTop='30px'/>
            </>
          )
          : ''}

        {stockCert.length > 0 ?
          (
            <>
              {stockCert.map((stock, index) => {
                return (
                  <div>
                    {
                      index === 0 ?
                        <>
                          <ContributionName paddingBottom="15px">Stock Certificate</ContributionName>
                          <Content marginBottom="30px" mB='20px'>Please follow instructions provided.</Content>
                        </>
                        : ''
                    }
                    <CapsuleButtonWrapper marginBottom="30px">
                    <GiftWrapper>
                      <div>Gift Id: {stock.giftId}</div>
                      <CapsuleButton
                        text= "View Funding Instructions"
                        data-test="view-funding-instructions-7"
                        onClick={() => this.clickAssetHeldMF(stock, "stockCert", '/StockCertificate')}
                      />
                    </GiftWrapper>
                    </CapsuleButtonWrapper>
                  </div>
                )
              })}
              <ComponentDivider bottom='40px' mobileBottom='30px' top='40px' mobileTop='30px'/>
            </>
          )
          : ''}
      </>
    ) : null;
  }
}

const mapStateToProps = state => ({
  ...fundingInstructionsState(state.toJS())
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(ContributionType)
);
